<template>
    <div class="page">
        <ion-grid>
            <ion-row class="row-divider"></ion-row>
            <ion-row class="row-divider"></ion-row>
            <ion-row class="list-view">
                <ion-col   >
                    <ion-row class="list-head margin-top-8">
                        <ion-col size="12" size-md="2">
                        <ion-label>Tariff Tag</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                            <ion-label>Time Of Unit</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                            <ion-label>Unit Consumed</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                            <ion-label>Unit Price</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                            <ion-label>Usage Cost</ion-label>
                        </ion-col>
                    </ion-row>
                    <hr />
                    <ion-row class="list-item margin-top-10 ion-align-items-center" v-for="(item, index) in usageList" :key="item.reservationDetailId">
                        <ion-col size="12" size-md="2" >
                            <ion-label>{{ item.tariffTag }}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                            <ion-label>{{ item.ToU }}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                            <div class="border-line-34 unit-input">
                                <ion-input v-model="item.unitsConsumed" @ionInput="updateUsageCost(item)" class="form-input" type="number"></ion-input>
                            </div>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                            <ion-label>{{ item.unitPrice }}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                            <ion-label>{{ item.usageCost }}</ion-label>
                        </ion-col>
                    </ion-row><br>
                    <ion-row class="totals-row ion-padding-top">
                        <ion-col size="12" size-md="2"></ion-col>
                        <ion-col size="12" size-md="1"></ion-col>
                        <ion-col size="12" size-md="2" class="ion-text-right"><strong>Actual kWh : </strong></ion-col>
                        <ion-col size="12" size-md="1">{{ totalUnitsConsumed.toFixed(3) }}</ion-col>
                        <ion-col size="12" size-md="2" class="ion-text-right"><strong>Usage Charge : </strong></ion-col>
                        <ion-col size="12" size-md="1">{{ totalUsageCost.toFixed(2) }}</ion-col>
                        <ion-col size="12" size-md="2" class="ion-text-right"><strong>Invoice Total : </strong></ion-col>
                        <ion-col size="12" size-md="1">{{ totalNetCost.toFixed(2) }}</ion-col>
                    </ion-row>
                </ion-col>
            </ion-row>
            
            <!-- <ion-row class="rectangle" v-for="(item, index) in usageList" :key="item.reservationDetailsId">
                <ion-col >
                    <ion-row align-items-stretch >
                        <ion-col size="12" size-md="3">
                            <ion-label class="section-item">Reservation ID <span class="required">*</span></ion-label>
                            <div class="border-line-34 margin-top-10">
                                <ion-input v-model="item.reservationId" class="form-input" type="text" readonly="true"></ion-input>
                            </div>
                        </ion-col>
                        <ion-col size="12" size-md="3">
                            <ion-label class="section-item" position="stacked">
                                Tariff Code <span class="required">*</span>
                            </ion-label>
                            <div class="border-line-34 margin-top-10">
                                <ion-input v-model="item.tariffCode" class="form-input" type="text" readonly="true"></ion-input>
                            </div>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                            <ion-label class="section-item" position="stacked">
                                Tariff Tag <span class="required">*</span>
                            </ion-label>
                            <div class="border-line-34 margin-top-10">
                                <ion-input v-model="item.tariffTag" class="form-input" type="text" readonly="true"></ion-input>
                            </div>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                            <ion-label class="section-item" position="stacked">
                                Time Of Unit <span class="required">*</span>
                            </ion-label>
                            <div class="border-line-34 margin-top-10">
                                <ion-input v-model="item.ToU" class="form-input" type="text" readonly="true"></ion-input>
                            </div>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                            <ion-label class="section-item">Unit Consumed <span class="required">*</span></ion-label>
                            <div class="border-line-34 margin-top-10">
                                <ion-input v-model="item.unitsConsumed" class="form-input" type="text"></ion-input>
                            </div>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                            <ion-label class="section-item">Unit Price <span class="required">*</span></ion-label>
                            <div class="border-line-34 margin-top-10">
                                <ion-input v-model="item.unitPrice" class="form-input" type="text" readonly="true"></ion-input>
                            </div>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                            <ion-label class="section-item">Usage Cost <span class="required">*</span></ion-label>
                            <div class="border-line-34 margin-top-10">
                                <ion-input v-model="item.usageCost" class="form-input" type="text" readonly="true"></ion-input>
                            </div>
                        </ion-col>
                    </ion-row>
                    <ion-row align-items-stretch>
                        <ion-col size="12" size-md="2">
                            <ion-label class="section-item">Unit Consumed <span class="required">*</span></ion-label>
                            <div class="border-line-34 margin-top-10">
                                <ion-input v-model="item.unitsConsumed" class="form-input" type="text"></ion-input>
                            </div>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                            <ion-label class="section-item">Unit Price <span class="required">*</span></ion-label>
                            <div class="border-line-34 margin-top-10">
                                <ion-input v-model="item.unitPrice" class="form-input" type="text" readonly="true"></ion-input>
                            </div>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                            <ion-label class="section-item">Usage Cost <span class="required">*</span></ion-label>
                            <div class="border-line-34 margin-top-10">
                                <ion-input v-model="item.usageCost" class="form-input" type="text" readonly="true"></ion-input>
                            </div>
                        </ion-col>
                    </ion-row>
                </ion-col>   
            </ion-row>  -->
            <ion-row align-items-stretch class="margin-top-10">
                <ion-col size="12" class="ion-text-right">
                    <ion-button class="btn-cancel btn-primary" @click="cancel">Cancel</ion-button>
                    <ion-button class="btn-primary col-nopadding" @click="usageUpdate">Update</ion-button>
                </ion-col>
            </ion-row>
        </ion-grid>
   </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonButton, IonCol, IonGrid, IonLabel, IonRow, IonInput, IonSelect, IonSelectOption, IonFabButton } from "@ionic/vue";
import datepicker from 'vue3-datepicker';
import { EVCStationReservationService } from "../../service/evcstation/reservation.service";
import VueDatePicker from '@vuepic/vue-datepicker';
import { ToastUtils } from "../../util/toast-utils";
import { AdminService } from "@/service/admin/admin.service";
import { migratedTryParseServiceError } from "../../service";
import { add, trash, timeOutline } from 'ionicons/icons';
import { LocalStorage } from "@/data/localstorage";

export default defineComponent({
    name: 'EditReservationUsage',
    components:{
        IonGrid, IonRow, IonCol, IonButton, IonLabel, IonInput, datepicker, IonSelect, IonSelectOption, IonFabButton, VueDatePicker
    },
    data(){
        return{
            reservationId: "",
            tariffCode: "",
            tariffTag: "",
            ToU: "",
            unitsConsumed: "",
            unitPrice: "",
            usageCost: "",
            usageList: [],
            actualGSTPercentage: '',
            usageDetails: [],
            reservationId: '',
            userId: '',
            stationId: '',
            installationId: '',
            oldConsumedUnit: '',
            oldUsageNettCost: '',
            actualCost:'',
            actualCGSTPercentage: '',
            actualSGSTPercentage: '',
            actualEndTime: '',
            reservationDetailsId: ''

        }
    },
    computed: {
        totalUnitsConsumed() {
            return this.usageList.reduce((total, item) => {
                return total + Number(item.unitsConsumed || 0);
            }, 0);
        },
        totalUsageCost() {
            return this.usageList.reduce(
            (total, item) => total + Number(item.usageCost || 0),
            0
            );
        },
        totalNetCost() {
            return +(this.totalUsageCost + this.actualGST).toFixed(2);
        },
        actualCGST() {
            const cost = Number(this.actualCost || 0);
            const percentage = Number(this.actualCGSTPercentage || 0);

            return +(cost * (percentage / 100)).toFixed(2);
        },
        actualSGST() {
            const cost = Number(this.actualCost || 0);
            const percentage = Number(this.actualSGSTPercentage || 0);

            return +(cost * (percentage / 100)).toFixed(2);
        },
        actualGST() {
            return +(this.actualCGST + this.actualSGST).toFixed(2);
        }

        
    },
    async mounted() {
         this.getUserUsageDetails();
    },
    beforeRouteLeave(to, from, next) {
        localStorage.removeItem('editReservationUsage');
        next();
    },
    methods: {
        async getUserUsageDetails() {
            try {
                let reservationId = Number(this.$route.params.reservationId);
                const result = JSON.parse(localStorage.getItem('editReservationUsage'));
                let invoiceDetails = await new EVCStationReservationService().getInvoiceDetailsById(reservationId);
                this.usageList = invoiceDetails || [];

                this.reservationId = reservationId;
                this.oldConsumedUnit = result?.commercial?.actual?.unit;
                this.oldUsageNettCost = result?.commercial?.actual?.nettCost;
                this.stationId = result?.station?.id;
                this.installationId = result?.gun?.setup?.id;
                this.actualCGSTPercentage = result?.commercial?.actual?.cgstrate;
                this.actualSGSTPercentage = result?.commercial?.actual?.sgstrate;
                this.actualGST = result?.commercial?.actual?.gstamount;
                this.actualCost = result?.commercial?.actual?.cost;
                this.actualEndTime = result?.slot?.endsOn;
                this.userId = result?.customer?.profile?.userId;
                this.reservationDetailsId = result?.invoiceDetails?.reservationDetailsId
                
            } catch (error) {
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }
        },
        cancel() {
            this.$router.back();
        },

        updateUsageCost(item) {
            const units = Number(item.unitsConsumed || 0);
            const price = Number(item.unitPrice || 0);

            item.usageCost = +(units * price).toFixed(3);
        },

        formatDate(date) {
            return date ? new Date(date).toISOString().split('T')[0] : new Date().toISOString().split('T')[0];
        },
        
        async usageUpdate() {
            try {
                const payload = {
                    data: {
                        usageDetails: this.usageList.map(item => ({
                            tariffCode: item.tariffCode,
                            tariffTag: item.tariffTag,
                            unitPrice: item.unitPrice,
                            ToU: item.ToU,
                            unitsConsumed: item.unitsConsumed,
                            usageCost: item.usageCost,
                            reservationDetailsId: item.reservationDetailsId
                        })),
                        reservationId: this.reservationId,
                        totalConsumedUnit: +this.totalUnitsConsumed.toFixed(3),
                        totalUsageCost: +this.totalUsageCost.toFixed(2),
                        totalUsageNettCost: +this.totalNetCost.toFixed(2),
                        oldConsumedUnit: this.oldConsumedUnit,
                        oldUsageNettCost: this.oldUsageNettCost ,
                        stationId: this.stationId,
                        installationId: this.installationId,
                        actualCGST: this.actualCGST,
                        actualSGST: this.actualSGST,
                        actualGST: this.actualGST,
                        userId: this.userId,
                        actualEndDate: this.formatDate(this.actualEndTime)
                    }
                };
                const response = await new EVCStationReservationService().saveReservationUsageDetails(payload, this.userId);

                if (response?.data?.success) {
                    new ToastUtils().presentToast(response.data.message);
                } 
                localStorage.removeItem('editReservationUsage');
                this.$router.go(-1)
            } catch (error) {
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }
        }
    }
})
</script>

<style scoped>
.col-nopadding {
    margin-right: 40px;
}
.unit-input {
    width: 80%;
}
.totals-row {
  font-weight: bold;
  border-top: 1px solid #ccc;
  margin-top: 16px;
}
.fab-group {
  display: flex;
  gap: 0; 
  padding: 5px;
}

.fab-btn {
  width: 20px;
  height: 20px;
  margin-top: 5px;
}

.time-icon {
    color: #21b24b;
}

.line-style {
    border-top: 1px solid #0b1c49 !important;
    margin: 0px;
    opacity: 1;
}
.btn-cancel {
    --background: #8c8b8b 0% 0% no-repeat padding-box;
}
</style>